import { noOp } from 'common/Constants';
import { Delimiter } from 'src/shared/design-system/Utilities/TextReplace';
import { POST_TEXT } from '../../consts';
import { PostHeaderProps } from '../../types';

export const useHeader = (props: PostHeaderProps) => {
  const {
    date,
    id,
    isLikedByUser,
    numLikes,
    onClickLike = noOp,
    onClickMessage,
    onClickReport,
    onClickUnfollow,
    shefImageUrl,
    shefName,
    showLikes,
    showMenu,
  } = props;

  const canClickUnfollow = !!onClickUnfollow;
  const canClickMessage = !!onClickMessage;
  const canClickReport = !!onClickReport;
  const canShowMenu = canClickUnfollow || canClickMessage || canClickReport;

  return {
    date,
    isLikedByUser,
    likeButtonProps: {
      hoverable: true,
      id,
      isLikedByUser,
      numLikes,
      onClickLike,
    },
    menuProps: {
      items: [
        ...(canClickUnfollow ? [{ label: POST_TEXT.HEADER.MENU.UNFOLLOW, onClick: onClickUnfollow ?? noOp }] : []),
        ...(canClickMessage
          ? [
              {
                label: POST_TEXT.HEADER.MENU.MESSAGE.replace(Delimiter, shefName ?? ''),
                onClick: onClickMessage ?? noOp,
              },
            ]
          : []),
        ...(canClickReport
          ? [
              {
                label: POST_TEXT.HEADER.MENU.REPORT,
                isError: true,
                onClick: onClickReport ?? noOp,
              },
            ]
          : []),
      ],
    },
    numLikes,
    onClickLike,
    onClickMessage,
    onClickReport,
    onClickUnfollow,
    shefName,
    shefImageUrl,
    showLikes,
    showMenu: showMenu && canShowMenu,
  };
};
